(function () {
  // === 1. 初始化按钮 ===
  const chatBtn = document.createElement('button');
  chatBtn.textContent = '💬 AI Assistant';
  chatBtn.style.position = 'fixed';
  chatBtn.style.bottom = '30px';
  chatBtn.style.right = '30px';
  chatBtn.style.padding = '16px 24px';
  chatBtn.style.fontSize = '18px';
  chatBtn.style.fontWeight = 'bold';
  chatBtn.style.borderRadius = '999px';
  chatBtn.style.background = '#ff5722'; // 橙红色醒目
  chatBtn.style.color = '#fff';
  chatBtn.style.border = '2px solid white';
  chatBtn.style.cursor = 'pointer';
  chatBtn.style.zIndex = '10000';
  chatBtn.style.boxShadow = '0 0 15px rgba(255,87,34,0.6)';
  chatBtn.style.transition = 'transform 0.2s ease-in-out';


  document.body.appendChild(chatBtn);

  // === 2. 创建聊天窗口 ===
  const chatBox = document.createElement('div');
  chatBox.style.position = 'fixed';
  chatBox.style.bottom = '60px';
  chatBox.style.right = '20px';
  chatBox.style.width = '300px';
  chatBox.style.height = '400px';
  chatBox.style.background = '#fff';
  chatBox.style.border = '1px solid #ccc';
  chatBox.style.borderRadius = '10px';
  chatBox.style.padding = '10px';
  chatBox.style.display = 'none';
  chatBox.style.flexDirection = 'column';
  chatBox.style.zIndex = 10001;
  chatBox.style.boxShadow = '0 0 10px rgba(0,0,0,0.2)';
  chatBox.style.fontFamily = 'sans-serif';
  chatBox.style.width = '1200px';
  chatBox.style.height = '1600px';
  chatBox.style.maxHeight = '80vh';
  chatBox.style.maxWidth = '90vw';
  chatBox.style.background = '#ffffff';
  chatBox.style.border = '2px solid #ccc';
  chatBox.style.borderRadius = '12px';
  chatBox.style.boxShadow = '0 0 20px rgba(0,0,0,0.3)';
  chatBox.style.padding = '16px';
  chatBox.style.fontSize = '16px';
  chatBox.style.lineHeight = '1.5';
  chatBox.style.display = 'none';
  chatBox.style.zIndex = 9999;
  chatBox.style.position = 'fixed';
  chatBox.style.top = '50%';
  chatBox.style.left = '50%';
  chatBox.style.transform = 'translate(-50%, -50%)';



  const messages = document.createElement('div');
  messages.id = "messages_panel";
  messages.style.flex = '1';
  messages.style.overflowY = 'auto';
  messages.style.marginBottom = '10px';

  const input = document.createElement('input');
  input.placeholder = 'Please let me know your thoughts...';
  input.style.width = '100%';
  input.style.padding = '8px';
  input.style.border = '1px solid #ccc';
  input.style.borderRadius = '4px';
  input.style.padding = '12px';
  input.style.border = '1px solid #aaa';
  input.style.borderRadius = '6px';
  input.style.fontSize = '16px';


  chatBox.appendChild(messages);
  chatBox.appendChild(input);
  document.body.appendChild(chatBox);
  
  // === 3. 切换窗口显示 ===
  // chatBtn.onclick = () => {
  //   chatBox.style.display = chatBox.style.display === 'none' ? 'flex' : 'none';
  // };
  chatBox.style.transition = 'all 0.3s ease-in-out';
  chatBox.style.opacity = '0';
  
  chatBtn.onclick = () => {
    const isVisible = chatBox.style.display === 'flex';
    chatBox.style.display = isVisible ? 'none' : 'flex';
    chatBox.style.opacity = isVisible ? '0' : '1';
  };

  // === 4. 发送消息 ===
  let chatHistory = ["你是电商导购，根据用户的需求列出解决方案并把解决方案中的产品生成搜索关键字（英文）,返回有效 JSON 格式，所有键名和字符串值必须加上双引号，输出必须严格符合以下结构:{keywords:[],natural_language:\"\"},其中natural_language是自然语言的答复,关键字将被用于产品搜索，搜索结果会显示在对话中，用户不需要知道关键字。重视用户最后一次的要求。与用户的历史对话如下："];
  let keywordHistory = {};window.keywordHistory = keywordHistory;
  // let hidden_message_data = {};window.hidden_message_data = hidden_message_data;
  window.send_hidden_chat_message = async function (hidden_message){
    // 显示“处理中...”
    const loading = document.createElement('div');
    hidden_message_data = JSON.parse(hidden_message);
    console.log("Hidden mesage sent: ",hidden_message_data);
    if(hidden_message_data.function&&hidden_message_data.function=="get_item_details"){
      // 读取单个产品明细
      try {
        const res = await fetch('https://ihenjstk4d.execute-api.us-west-2.amazonaws.com/default/pythonServer?url=redirect_2&action=ai', {method: 'POST',headers: {'Content-Type': 'application/json'},body: JSON.stringify({ message: chatHistory.join(";"),hidden_message:hidden_message })});
        const data = await res.json();
        console.log("Processed data from ebay",data.products[0]);
        let processed_product_data = createProductPopup(data.products[0].node); // go to product detail page instead.
        
        // 检查shopify后端是否有相应的产品，并执行后续操作
        try {
          params = JSON.stringify({function:"check_shopify_product_and_create",product:processed_product_data});          
          document.getElementById("product_popup_buy_btn").innerHTML = "Preparing product, please wait...";
          document.getElementById("product_popup_buy_btn").style.backgroundColor = "gray";
          const res = await fetch('https://ihenjstk4d.execute-api.us-west-2.amazonaws.com/default/pythonServer?url=redirect_2&action=ai', {method: 'POST',headers: {'Content-Type': 'application/json'},body: JSON.stringify({ message: chatHistory.join(";"),hidden_message:params })});
          const data = await res.json();
          console.log("Result of check_shopify_product_and_create",data);
          if(data.errors){
            document.getElementById("product_popup_buy_btn").innerHTML = "Product not available";
            // document.getElementById("product_popup_buy_btn").style.backgroundColor = "#ff5a00";
            // document.getElementById("product_popup_buy_btn").setAttribute("href",data.link);
          }else{
            document.getElementById("product_popup_buy_btn").innerHTML = "Buy it now";
            document.getElementById("product_popup_buy_btn").style.backgroundColor = "#ff5a00";
            document.getElementById("product_popup_buy_btn").setAttribute("href",data.link);
          }          
        }catch(e){}
      }catch(e){}

      
    }else{
      // 其他AI请求
      loading.textContent = '🤖 Thinking...';
      messages.appendChild(loading);        
      try {
        const res = await fetch('https://ihenjstk4d.execute-api.us-west-2.amazonaws.com/default/pythonServer?url=redirect_2&action=ai', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ message: chatHistory.join(";"),hidden_message:hidden_message })
        });
        const data = await res.json();
        loading.remove();
        show_products(data);
      }catch(e){}
    }
  }
  let ebay_keyword = "";
  let ebay_cursor = "";
  // function check_keyword_history(k,h){    for(var i=0;i<h.length;i++){      if(h[i].keyword == k){        return true;      }    }    return false;  }
  function show_products(data){
    // 记录关键字
    if(data.keyword&&!keywordHistory[data.keyword])keywordHistory[data.keyword]={keyword:data.keyword,cursor:data.cursor,cateid:data.cateid};
    if(data.function&&(data.function=="cheap_search"||data.function=="continue_search")){
      if(data.price&&data.price>0){
        if(!keywordHistory[data.keyword]["cheaper"]){keywordHistory[data.keyword]["cheaper"]={};}
        keywordHistory[data.keyword]["cheaper"][data.price] = {keyword:data.keyword,cursor:data.cursor,cateid:data.cateid,price:data.price};
      }
    }
    keywordHistory[data.keyword].cursor_ebay = data.cursor_ebay;
    keywordHistory[data.keyword].cursor = data.cursor;
    // 显示推荐商品
    if (data.products && data.products.length > 0) {
      let count = 0;
      data.products.forEach((p) => {
        let productCard = document.createElement('div');
        productCard.style.border = '1px solid #eee';
        productCard.style.marginTop = '10px';
        productCard.style.padding = '10px';
        productCard.style.borderRadius = '6px';
        productCard.style.backgroundColor = '#fafafa';
      
        let ebay_id = p.node.ebay_id;
        if (p.node.ebay_keyword) {
          ebay_keyword = p.node.ebay_keyword;
        }
        if(p.node.ebay_cursor){          
          ebay_cursor = p.node.ebay_cursor;
        }
        let cursor_dict = "";
        let ebay_price = p.node.priceRange.minVariantPrice.amount;
        let ebay_cate_id = p.node.ebay_cate_id;
        let ebay_cate_name = p.node.ebay_cate_name;
        let title = p.node.title || "No title";
        let price = p.node.priceRange?.minVariantPrice?.amount || "--";
        let currency = p.node.priceRange?.minVariantPrice?.currencyCode || "USD";
        let image = p.node.image || "";  // 注意：你现在没有使用 GraphQL 的 edges 结构，image 是直接给出的 URL
        let handle = p.node.handle || "";
        let productLink = p.node.url || `/products/${handle}`;
        let product_total = p.node.total;
        let ebay_group_href = p.node.ebay_group_href;
      
        productCard.innerHTML = `
          <div style="display: flex; gap: 12px; align-items: flex-start;">
            ${image ? `<img src="${image}" style="width:50%;max-width:300px; border-radius:4px; margin-bottom:8px;" />` : ""}
            <div style="flex: 1;">
              <strong>${title}</strong><br/>
              💰 ${price} ${currency}<br/>
            </div>
          </div>
          <a href="javascript:void(0)" data-function="get_item_details" data-title="${title}" data-id="${ebay_id}" data-eportalid="${p.node.id}" data-grouphref="${ebay_group_href}" onclick="window.send_hidden_chat_message(JSON.stringify({function:this.dataset.function,title:this.dataset.title,id:this.dataset.id,eportalid:this.dataset.eportalid,grouphref:this.dataset.grouphref}))">🔗 Show details</a>
          <!--a href="javascript:void(0)" data-function="cheap_search" data-keyword="${title}" data-cateid="${ebay_cate_id}" data-price="${ebay_price}" data-cursor="${cursor_dict}" onclick="window.send_hidden_chat_message(JSON.stringify({function:this.dataset.function,keyword:this.dataset.keyword,cateid:this.dataset.cateid,price:this.dataset.price,cursor:window.keywordHistory}))">🔗 Cheaper offers</a-->
          <a href="javascript:void(0)" data-function="refine_keyword_from_title_search" data-keyword="${title}" data-cateid="${ebay_cate_id}" data-cursor="${cursor_dict}" onclick="window.send_hidden_chat_message(JSON.stringify({function:this.dataset.function,keyword:this.dataset.keyword,cateid:this.dataset.cateid,cursor:window.keywordHistory}))">🔗 Similar products</a>
        `;
        messages.appendChild(productCard);
        saveChat();
        
        // 只移到第一个新刷的
        count++; if(count == 1) {
          const images = productCard.querySelectorAll('img');
          let loadedCount = 0;
          const scrollToCard = () => {
            const top = productCard.offsetTop;
            messages.scrollTop = top;
          };
          
          if (images.length === 0) {
            // 如果没有图片，立即滚动
            messages.scrollTop = messages.scrollHeight;
          } else {
            // 有图片，等图片加载完后再滚动
            images.forEach((img) => {
              img.onload = img.onerror = () => {
                loadedCount++;
                if (loadedCount === images.length) {
                  scrollToCard();
                }
              };
            });
          }
        }
        if(count == data.products.length){
          // 如果刷到头了就显示这个信息，并且让相应的搜索没法继续搜
          let search_ended = null
          if(product_total <= data.cursor+5){
            let no_result_msg = document.createElement("div");
            no_result_msg.innerHTML = "🔗 No more results for:" + data.keyword + " " + (data.price?("$"+data.price+" lower"):"");
            messages.appendChild(no_result_msg);
            saveChat();
            search_ended = {keyword:data.keyword,price:data.price}
          }
          // console.log(search_ended)
          let continue_search_btn = document.createElement("div");
          continue_search_btn.innerHTML = `🔗 Search more for:`;
          for(var k in keywordHistory){
            item = keywordHistory[k];
            continue_search_btn.innerHTML +=  `<br><a href="javascript:void(0)" data-function="continue_search" data-keyword="${item.keyword}" data-cursor_ebay="${item.cursor_ebay}" data-cursor="${item.cursor}" data-cateid="${(item.cateid?item.cateid:"")}" onclick="window.send_hidden_chat_message(JSON.stringify({function:this.dataset.function,keyword:this.dataset.keyword,cursor:this.dataset.cursor,cursor_ebay:this.dataset.cursor_ebay,cateid:this.dataset.cateid}))">${item.keyword}</a>`
            if(search_ended&&search_ended.keyword==item.keyword&&!search_ended.price){continue_search_btn.lastChild.setAttribute("onclick","search_ended")}
            if(item["cheaper"]){
              for(var p in item.cheaper){
                continue_search_btn.innerHTML +=  `<br><a href="javascript:void(0)" data-function="continue_search" data-keyword="${item.keyword}" data-cursor="${item.cheaper[p].cursor}" data-total="${item.cheaper[p].total}" data-cateid="${(item.cateid?item.cateid:"")}" data-price="${item.cheaper[p].price}" onclick="window.send_hidden_chat_message(JSON.stringify({function:this.dataset.function,keyword:this.dataset.keyword,cursor:this.dataset.cursor,total:this.dataset.total,cateid:this.dataset.cateid,price:this.dataset.price}))">${item.keyword+" < $"+p}</a>`
                if(search_ended&&search_ended.keyword==item.keyword&&search_ended.price==item.cheaper[p].price){continue_search_btn.lastChild.setAttribute("onclick","search_ended")}
              }
            }
          }
          messages.appendChild(continue_search_btn);
          saveChat();
        }
      });
    }
    else if (data.products && data.products.length == 0){
      let no_result_msg = document.createElement("div");
      no_result_msg.innerHTML = "🔗 No more results for:" + data.keyword + " " + (data.price?("$"+data.price+" lower"):"");
      messages.appendChild(no_result_msg);
      saveChat();
      messages.scrollTop = messages.scrollHeight;
    }
  }
  
  input.addEventListener('keypress', async (e) => {
    if (e.key === 'Enter' && input.value.trim()) {
      const msg = input.value.trim();
      const msgEl = document.createElement('div');
      msgEl.textContent = '🧑 : ' + msg;
      msgEl.style.margin = '5px 0';
      messages.appendChild(msgEl);
      chatHistory.push(msgEl.textContent);
      input.value = '';

      // 显示“处理中...”
      const loading = document.createElement('div');
      loading.textContent = '🤖 Thinking...';
      messages.appendChild(loading);

      try {
        const res = await fetch('https://ihenjstk4d.execute-api.us-west-2.amazonaws.com/default/pythonServer?url=redirect_2&action=ai', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ message: chatHistory.join(";") })
        });
        
        const data = await res.json();
        loading.remove();
        console.log(data);
        const reply = document.createElement('div');
        reply.textContent = '🤖 ' + data.reply;
        reply.style.margin = '5px 0';
        reply.style.whiteSpace = 'pre-wrap';
        messages.appendChild(reply);
        if(data.function){chatHistory.push(data.function+":...;");}else{chatHistory.push(reply.textContent);}

        // 显示推荐商品
        if (data.products && data.products.length > 0) {
          console.log("Product listing data",data.products)
          show_products(data);
        }
        // 显示推荐商品关键字
        else if (data.keywords && data.keywords.length > 1) {
          data.keywords.forEach((k) => {
            const keywordCard = document.createElement('div');
            keywordCard.style.border = '1px solid #eee';
            keywordCard.style.marginTop = '5px';
            keywordCard.style.padding = '5px';
            hidden_message = {function:"search",keyword:k};
            keywordCard.dataset.msg = JSON.stringify(hidden_message);//console.log(keywordCard.dataset.msg)
            keywordCard.innerHTML = `
              <strong>${k}</strong><br/>
            `;
            keywordCard.onclick = (e) => send_hidden_chat_message(e.currentTarget.dataset.msg);
            messages.appendChild(keywordCard);
          });
        }

        messages.scrollTop = messages.scrollHeight;
      } catch (err) {
        loading.remove();
        const error = document.createElement('div');
        error.textContent = '❌ 请求失败，请稍后重试';
        error.style.color = 'red';
        messages.appendChild(error);
      }
    }
  });
  function convert_time(isoString){
    let date = new Date(isoString);    
    let options = { timeZone: "Australia/Sydney", year: "numeric", month: "long", day: "numeric" };    
    return date.toLocaleDateString("en-AU", options);
  }
  function createProductPopup(product) {
    console.log("Product data for details",product)
    document.body.style.overflow = 'hidden';
    // 若已存在 popup，则先移除
    const existing = document.getElementById("popup-overlay");
    if (existing) existing.remove();
  
    const overlay = document.createElement("div");
    overlay.id = "popup-overlay";
    overlay.className = "popup-overlay";
    product.shippingData.shippingCost = 10.00;
    overlay.innerHTML = `
      <div id="popup-content" class="popup-content">
        <div class="popup-close"><span onclick="document.getElementById('popup-overlay').remove();document.body.style.overflow = '';">×</span></div>
        <img style="width:100%" src="${product.image}" alt="${product.title}">
        <h3>${product.title}</h3>
        <p><strong>💰 Price:</strong>  ${"From "+product.priceRange.minVariantPrice.amount} ${product.priceRange.minVariantPrice.currencyCode}</p>
        ${product.seller?("<p><strong>🧸 Seller:</strong>"+product.seller.username+"("+product.seller.feedbackPercentage+"%, "+product.seller.feedbackScore+" ratings)</p>"):""} 
        <p><strong>🚚 Availability:</strong> ${(product.estimatedAvailabilities[0].estimatedAvailabilityStatus=="IN_STOCK")?"In stock":"Out of stock"}</p>
        <p><strong>📦 Shipping Cost:</strong> ${ (product.shippingData.shippingCost == 0 )?"Free":"A$" + product.shippingData.shippingCost} </p>
        <p><strong>📅 Delivered By:</strong> ${convert_time(product.shippingData.ShippingArriveBy)} </p>
        <p><strong>🔁 Return Policy:</strong> ${product.returnTerms.returnsAccepted?("Return in "+product.returnTerms.returnPeriod.value+" days accepted"):"No return"} </p>
        <div style="margin-top:8px;">
          <a id="product_popup_buy_btn" href="Javascript:void(0)" style="display:inline-block;padding:6px 12px;background:#ff5a00;color:white;border:none;border-radius:4px;text-decoration:none;font-weight:bold;">🛒 Buy It Now</a>
        </div>
        <div id="product_popup_description" class="discription"><strong>📦 Description:</strong> <br> ${product.description
          .replace(/<style[\s\S]*?<\/style>/gi, '') // 移除 <style> 标签及内容
          .replace(/<!\[CDATA\[(.*?)\]\]>/gs, '$1') // 解包 CDATA
          .replace(/<!--[\s\S]*?-->/g, '') // 移除注释
          .replace(/<(?!\/?(img|table|tr|th|td)\b)(\/?)(\w+)([^>]*)>/gi, '<$2p$4>') // 替换标签为 <p>
        }</div>
        <button id="popupBackToTopBtn" style="float:right;position: sticky;bottom: 5px;right: 30px;padding: 8px 12px;background-color: #333;color: white;border: none;border-radius: 4px;font-size: 12px;cursor: pointer;z-index: 10001;display: none;">↑ Top</button>
      </div>
    `;
    document.body.appendChild(overlay);
    // replaceTagsRecursively(document.querySelector('.description'));
    document.querySelectorAll('.discription p').forEach(p => {
      if (!p.innerHTML.replace(/&nbsp;|\s/g, '')) p.remove();
      p.setAttribute("style","word-break: normal;");
    });
    
    document.querySelectorAll('.discription img').forEach(img => {      img.style.width = "100%";img.style.height = "auto";    });
    document.querySelectorAll('.discription table').forEach(table => {      table.style.width = "90%";    });
    document.querySelectorAll('.discription tr').forEach(t => {      t.setAttribute("style","");    });
    document.querySelectorAll('.discription th').forEach(t => {      t.setAttribute("style","");    });
    document.querySelectorAll('.discription td').forEach(t => {      t.setAttribute("style","word-break: normal;");   });
    // Scroll back to top
    const popupContent = document.getElementById("popup-content");
    const popupBackToTopBtn = document.getElementById("popupBackToTopBtn");    
    popupContent.addEventListener("scroll", () => {
      if (popupContent.scrollTop > 100) {
        popupBackToTopBtn.style.display = "block";
      } else {
        popupBackToTopBtn.style.display = "none";
      }
    });    
    popupBackToTopBtn.addEventListener("click", () => {
      popupContent.scrollTo({ top: 0, behavior: 'smooth' });
    });
    product.description = document.getElementById("product_popup_description").innerHTML; // 更新产品描述
    return product;
  }
  
  const popup_style = document.createElement("style");
  popup_style.innerHTML = `
  .popup-overlay {
    position: fixed;
    top: 0; left: 0;
    width: 100vw; height: 100vh;
    background: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
    height: 100%;
  }
  .popup-content {
    background: #fff;
    border-radius: 10px;
    padding: 20px;
    max-width: 500px;
    width: 90%;
    max-height: 80%;
    overflow: auto;
    box-shadow: 0 0 10px rgba(0,0,0,0.2);
    position: relative;
    font-family: Arial, sans-serif;
    padding-top:0px;
  }
  .popup-close {
    position: sticky;
    text-align:right;
    background-color:white;
    top: 0px; right: 15px;
    font-size: 24px;
    color: #888;
  }
  .popup-close span{
    cursor: pointer;
    padding:5px;
  }
  .popup-header {
    display: flex;
    gap: 15px;
    margin-bottom: 15px;
    align-items: center;
  }
  .popup-image {
    width: 120px;
    height: auto;
    border-radius: 6px;
  }
  .popup-main-info {
    flex-grow: 1;
  }
  .popup-title {
    margin: 0 0 5px;
    font-size: 16px;
    font-weight: bold;
  }
  .popup-price {
    color: #0077cc;
    font-weight: bold;
  }
  .popup-body p {
    margin: 8px 0;
    font-size: 14px;
  }
  .popup-link {
    display: inline-block;
    margin-top: 12px;
    color: #0077cc;
    text-decoration: none;
  }
  .popup-link:hover {
    text-decoration: underline;
  }`;
  const meta = document.createElement('meta');  meta.name = "viewport";  meta.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no";
  
  document.head.appendChild(meta);
  document.head.appendChild(popup_style);
  function openDB(callback) {
    const request = indexedDB.open('MyDB', 1);
  
    request.onupgradeneeded = function (event) {
      const db = event.target.result;
      if (!db.objectStoreNames.contains('MyStore')) {
        db.createObjectStore('MyStore');
      }
    };
  
    request.onsuccess = function (event) {
      callback(null, event.target.result);
    };
  
    request.onerror = function () {
      callback(new Error('Failed to open DB'), null);
    };
  }
  
  function saveStringToIndexedDB(key, value) {
    openDB((err, db) => {
      if (err) return console.error(err);
      const tx = db.transaction('MyStore', 'readwrite');
      tx.objectStore('MyStore').put(value, key);
    });
  }
  
  function loadStringFromIndexedDB(key, callback) {
    openDB((err, db) => {
      if (err) return callback(null);
      const tx = db.transaction('MyStore', 'readonly');
      const request = tx.objectStore('MyStore').get(key);
  
      request.onsuccess = () => callback(request.result);
      request.onerror = () => callback(null);
    });
  }
  let oldChat;
  loadStringFromIndexedDB("chat", function(result) {
    oldChat = result;
    if(oldChat){
      oldChat = JSON.parse(oldChat);
      keywordHistory = oldChat.keywordHistory;
      chatHistory = oldChat.chatHistory;
      messages.innerHTML = oldChat.messagesInnerHTML;
      chatBtn.click();
      messages.scrollTop = messages.scrollHeight;
      chatBtn.click();
    }else{
      oldChat = {
        keywordHistory:keywordHistory,
        chatHistory:chatHistory,
        messagesInnerHTML:messages.innerHTML
      }
    }
  });
  
  function saveChat(){
    oldChat.messagesInnerHTML = messages.innerHTML;
    oldChat.chatHistory = chatHistory;
    oldChat.keywordHistory = keywordHistory;
    saveStringToIndexedDB("chat",JSON.stringify(oldChat));
  }
  
})();

